import Vue from 'vue';
import api from '../bu/api';
import moment from 'moment';

export default {
	namespaced: true,

	state: () => ({
		bookingPasses: {},
		bookingPassesArray: [],
		paging: null,
		bookingPassOptions: [],
	}),

	getters: {
		bookingPassOptions(state) {
			return state.bookingPassOptions
		},
		bookingPasses(state) {
			return state.bookingPassesArray.sort((a, b) => {
				if (a.archived_at && b.archived_at) {
					return moment(a.archived_at).isBefore(moment(b.archived_at)) ? 1 : -1;
				}

				const isExpired = (bookingPass) => {
					if (bookingPass.expire_at) {
						const now = moment();
						const expiredAt = moment(bookingPass.expired_at).tz('GMT');
						return now.isAfter(expiredAt);
					} else {
						return false;
					}
				}

				a.isExpired = isExpired(a);
				b.isExpired = isExpired(b);

				if (a.isExpired && !b.isExpired) {
					return 1;
				} else if (!a.isExpired && b.isExpired) {
					return -1;
				}

				return b.id - a.id;
			});
		},
		bookingPassesMap(state) {
			return state.bookingPasses;
		},
		paging(state) {
			return state.paging;
		},
	},

	actions: {
		async getBookingPassOptions({commit}) {
			const response = await api.getBookingPassOptions();
			commit('setBookingPassOptions', response.data);
		},
		async getCustomersForBookingPass({commit}, {bookingPassId}) {
			const response = await api.getCustomersForBookingPass(bookingPassId);
			return response.data;
		},
		async getBookingPasses({commit}, {page, archived}) {
			const response = await api.getBookingPasses(page, archived);
			commit('setBookingPasses', response.data.data);
			commit('setPaging', response.data);
			return response.data.data.map((bookingPass) => bookingPass.id);
		},
		async getServiceRelatedBookingPasses({commit}, serviceId) {
            const passes = (await api.getServiceRelatedBookingPasses(serviceId)).data;
			commit('setBookingPasses', passes);
			return passes;
		},
		async saveBookingPass({commit}, { bookingPass, photoFile }) {
			const response = await api.saveBookingPass(bookingPass, photoFile);
			commit('setBookingPass', response.data);
			return response.data;
		},
		async saveBookingPassPresets({commit}, { bookingPass, presets }) {
			const response = await api.saveBookingPassPresets(bookingPass, presets);
			commit('setBookingPassPresets', { bookingPass, presets: response.data });
			return response.data;
		},
		async archiveBookingPass({commit}, bookingPassId) {
			const bookingPass = await api.archiveBookingPass(bookingPassId);
			commit('setBookingPassArchived', bookingPass);
		}
	},

	mutations: {
		setBookingPassArchived(state, bookingPass) {
			state.bookingPasses[bookingPass.id] = bookingPass;
		},
		setBookingPassOptions(state, options) {
			state.bookingPassOptions = options;
		},
		setBookingPass(state, bookingPass) {
			Vue.set(state.bookingPasses, bookingPass.id, bookingPass);
			Vue.set(state, 'bookingPassesArray', Object.values(state.bookingPasses));
		},
		setBookingPassPresets(state, {bookingPass, presets}) {
			state.bookingPasses[bookingPass.id].presets = presets;
		},
		setBookingPasses(state, bookingPasses) {
			state.bookingPasses = {};
			bookingPasses.forEach((bookingPass) => {
				Vue.set(state.bookingPasses, bookingPass.id, bookingPass);
			});
			Vue.set(state, 'bookingPassesArray', Object.values(state.bookingPasses));
		},
		setPaging(state, paging) {
			state.paging = paging;
		},
	},
}
